import animationData from '../../Animation-Pink.json';
import React from 'react';
import Lottie from 'lottie-react';

const LottieSpinner: React.FC<{ size?: number }> = ({ size = 80 }) => (
  <div style={{ width: size, height: size, display: 'inline-block' }}>
    <Lottie animationData={animationData} loop={true} />
  </div>
);

export default LottieSpinner; 